<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-9 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

    

        <!---SEARCH BOX-->
         <div class="col-md-3">
          <div class="searchbox input-group" role="group">
          <input class="form-control search-box my-search-box" type="text" placeholder="Username or Company" aria-label="search" v-model="filteredText">
         
          <button class="search-button btn btn-primary filter"  @click="getUsers()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
       
       </div>
       <div class="row"><div class="col"><hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;"></div></div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader" style="width: 8%">User Name</th>
                <th role="columnheader" style="width: 20%">Full Name</th>
                <th role="columnheader" style="width: 15%">Company</th>
                <th role="columnheader" style="width: 10%">Email</th>
                <th role="columnheader" style="width: 10%">Phone</th>
                <th role="columnheader" style ="width:10%">Role </th>
                <th role="columnheader" style ="width:10%">Action </th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "Users===null" >
                <td colspan="7"></td>
              </tr>
              
              

            <tr v-else v-for="user in Users" :key=user.id>
              <td  role="cell" style="text-decoration: underline;">
                <router-link :to="{ name: 'users', params: { user } }">
                      {{user.userName}}
                </router-link>
              </td>
              <td  role="cell">{{user.firstName}} {{user.lastName}}</td>
             
              <td  role="cell">{{user.companyName}}</td>
              <td  role="cell">{{user.email}}</td>
              <td  role="cell">{{user.phoneNumber}}</td>
              <td  role="cell">{{user.role}}</td>
              <td>
               
                <span title = "Restore" @click= "passRecordToReactive(user.id)">
                  <i role="button" style="color:green" class="fas fa-recycle"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getUsers()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
          <b-pagination
            v-model= "page"
            :total-rows= rows
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            @change="getPage"
          ></b-pagination>
         
        </div>
      </div>
       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="Users==null" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
    <DeleteUserModal :entityId = "userToDelete" :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading= "deleteModalHeading"/>
   
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import DeleteUserModal from '../../modals/DeleteModal'
export default {
    name: 'deletedusers',
    mounted()
    {
      console.log(this.$auth.user());
    },
    data(){
        return{
          moduleName:'Deleted Users',
          Id:null,
          UserName:'',
          FirstName:'',
          LastName:'',
          Email:'',
          Password:'',
          PhoneNumber:'',
          Role:null,
          Company:null,
          msgForModal :"Confirm to Restore !",
          apiEndPoint: "user/restore/",
          deleteModalHeading:"Restore User",
          userToDelete:null,
          Users:[''],

          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25
         
		}
  },

methods:{
  getPage(page)
  {
    this.page = page;
    this.getUsers();
  },
  
 
  passRecordToReactive(id)
  {
    this.userToDelete = id;
    this.msgForModal = "Confirm to Restore !";
    this.apiEndPoint = "user/restore/";
    this.deleteModalHeading = "Restore User"
    this.$bvModal.show('DeleteModal')

  },
 
    getUsers(){
      axios.post('/user/getall',{"PageSize":this.perPage,"Page":this.page,"Text":this.filteredText,"IsActive":false})
    .then(res=>{
     
      this.Users=res.data.data;
    
      this.rows = res.data.totalRecords
     
    });
  },
	
   


  search(){
   
    this.page=this.pageNumOnSearch;
    this.getUsers();
  }
  },
	created(){
    this.getUsers();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    
    DeleteUserModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}

.col{
  padding-left:0px;
  padding-right:0px;
}

</style>